/* template */
<template minapp="mpx" xlang="wxml"><div class="mpx-root-view"><es-layout leftArrow navbarTitle="改签详情" custom-class="nav" custom-title="custom-title" custom-navbar="custom-navbar" :layout="(['header', 'footer'])" :navbarStyle="(navbarStyle)" :useBlankPage="(loadingPage||loadInitDataFail)" :blankPageType="(loadingPage ? 'loading' : loadInitDataFail ? 'blank-page' :'')" :esMainStyle="(loadingPage ? esLoadingStyle :esMainStyle)" :blankContextSubTitle="(loadFailText)" @blank-retry="loadChangeDetail" @scrolling="pageScroll"><mpx-view @touchstart="touchStart" @touchmove="touchMove" @touchend="touchEnd" :style='[("transform:"+(transformY)+";")] | transRpxStyle'><div class="pulldown" v-if="(showPullDown)"><mpx-image :src="(loadingImg)" class="pulldown-loading"/><div class="pulldown-text">松开立即刷新</div></div><train-swiper :initIndex="(currentIndex)" @change="onChange" :showReason="(false)" :listData="(changeDetailList)"/><div :class='"order-info-bg"' v-if="(currentData)"><order-flow-info :currOrder="(currentData)" :list="(currentData != null ? currentData.time_sequence : [])"><div slot="title"><mpx-view @tap="onShowPriceDetail" class="order-title"><div :style='["align-items:center; display:flex"] | transRpxStyle'><es-icon size="24" :name="(iconName)" class="order-left"/>{{
									currentData != null ? currentData.status_name : ''
								}}</div><div v-if="(showPriceSub)"><div class="order-price-detail">费用明细<es-icon size="16" name="angle-right"/></div></div></mpx-view></div></order-flow-info></div><div :style='["margin-left: 12px"] | transRpxStyle'><ticket-card :ticketInfo="(oldTicketInfo)"/></div></mpx-view></es-layout><price-detail-info-alter :show="(showPriceDetail)" :priceDetail="(currentData.fee_detail)" @close="closePriceDetail" v-if="(currentData)"/></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m3f21578c"}'>
 @import '~@/mixins/stylus/color.styl'

 .pulldown
 	display flex
 	justify-content center
 	align-items center
 	width 100%
 	height 40px
 .pulldown-text
 	font-size 14px
 	color #FFFFFF
 	padding-right 28px
 .pulldown-loading
 	width 20px
 	height 20px
 	margin-right 15px
 	animation spin 2s linear infinite
 @keyframes spin
 	0%
 		transform rotate(0deg)
 	100%
 		transform rotate(360deg)
 .custom-title
 	font-size 18px
 	font-family PingFangSC
 .nav
 	/deep/ .es-navbar
 		background-color $train-color-theme-blue
 		color #ffffff
 		font-family PingFangSC
 		font-size 18px
 .custom-navbar
 	background-color $train-color-theme-blue
 	color #ffffff
 	font-family PingFangSC
 	font-size 18px
 .list-main
 	padding-bottom 10px
 	box-sizing border-box
 .order-info-bg
 	background-color rgb(240, 241, 244)
 	height 100%
 	padding 12px
 	box-sizing border-box
 	border-radius 12px 12px 0px 0px
 	overflow auto
 .order-title
 	color $train-color-theme-blue
 	font-size 16px
 	height 69px
 	font-weight 600
 	display flex
 	align-items center
 	flex-direction row
 	justify-content space-between
 .order-price-detail
 	display flex
 	font-size 12px
 	font-weight 400
 	color $train-color-999
 	justify-content flex-end
 	align-items center
 .order-left
 	margin-right 6px
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m3f21578c"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./change-ticket-detail-page.mpx.js?isPage!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./change-ticket-detail-page.mpx?ctorType=page&index=0&isPage&mpx&type=script")
  const currentOption = global.__mpxOptionsMap["m3f21578c"]
  export default processOption(
    currentOption,
    "page",
    "",
    "",
    {"navigationBarTitleText":""},
    // @ts-ignore
    {},
    // @ts-ignore
    {'train-swiper':getComponent(require("../refund-ticket/components/train-swiper-card.mpx?isComponent&outputPath=components%2Ftrain-swiper-card2722b72c%2Findex")),'refund-detail-info-alert':getComponent(require("../refund-ticket/components/refund-detail-info-alert.mpx?isComponent&outputPath=components%2Frefund-detail-info-alert410c8328%2Findex")),'ticket-card':getComponent(require("./components/change-ticket-card.mpx?isComponent&outputPath=components%2Fchange-ticket-card4e3da240%2Findex")),'price-detail-info-alter':getComponent(require("../../components/price-detail-info-alter/index.mpx?isComponent&outputPath=components%2Findex853d8b3a%2Findex")),'order-flow-info':getComponent(require("../../components/order-flow-info/index.mpx?isComponent&outputPath=components%2Findex7c1a2e22%2Findex")),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
